import type { Currency, ReportColumn, ReportRecordsQuery } from '@chukua/common';
import type { TableColumnsType } from 'antd';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import { formatMoney } from '../../../shared/policies/format-money';
import type { ReportRecord } from '../reports.api';

/** The record fields a column can be sorted by (`reportRecordsQuerySchema`'s whitelist), by column key. */
const SORT_FIELDS: Record<string, ReportRecordsQuery['sort']> = { invoiceDate: 'date', amountMinor: 'amount' };

function renderCell(column: ReportColumn, record: ReportRecord): string {
  const value = record[column.key];
  if (value === null || value === undefined) return '';
  if (column.kind === 'money') return formatMoney({ amountMinor: Number(value), currency: record.currency as Currency });
  return String(value);
}

/** Columns from the report's own `columns`, so a new report needs no table code. Money is right-aligned and carries its record's currency. */
export function buildRecordColumns(columns: ReportColumn[], list: ListQueryControls<ReportRecordsQuery>): TableColumnsType<ReportRecord> {
  return columns.map((column) => {
    const sortField = SORT_FIELDS[column.key];
    return {
      key: column.key,
      title: column.label,
      align: column.kind === 'money' || column.kind === 'number' ? 'right' : 'left',
      sorter: sortField ? true : undefined,
      sortOrder: sortField ? list.sortOrderFor(sortField) : undefined,
      render: (_: unknown, record: ReportRecord) => renderCell(column, record),
    };
  });
}
